/*
 * @Autor: hansong27
 * @Email: hansong27@jd.com
 * @Description:
 * @CreateDate: Do not edit
 * @LastEditors: chengyan9
 */
import "./App.css";

import { useEffect, useRef } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import { useLocation } from "react-router-dom";

import { useSelector } from "react-redux";

import LrLayout from "@/layout/layout-lr";

import Cover from "@/pages/cover/index.jsx";
import Tenant from "@/pages/tenant/index";
import Home from "@/pages/home/index";
import LsHome from "@/pages/LsHome/index";

import IframeView from "@/components/iframe-view";
import MicroAppView from "@/components/microapp-view";

import { TStoreData } from "@/interface";
import { saasTree } from "@/api/menu";

import { getPathUrl, getSaasActiveMenuInfo, getUrlParams } from "@/util/tools";
import store from "@/store";
import { switchTenant, tenantListTree } from "./api/tenant";
import { getFlow, Flow } from "@/constants";
import { useHistory } from "react-router";
import Login from "./pages/login";
import { MAP_TENANT_FIRST_CODE, TENANT_ENV } from "./constants/tenants";

function App() {
    const location = useLocation();
    const history = useHistory();
    const defaultFlow = useRef<Flow[]>([]);

    const storeData = useSelector((data: TStoreData) => {
        return {
            layoutMode: data?.layoutMode,
            subApp: data?.subApp,
            subAppMap: data?.subAppMap,
            flow: data?.flow || [],
            other: data?.other || [],
            subMenuList: data?.subMenuList || [],
            flowAndOtherActive: data?.flowAndOtherActive || "",
            firstTenant: data?.firstTenant || {},
        };
    });

    const { layoutMode, subApp, subAppMap, flow, firstTenant } = storeData;

    useEffect(() => {
        if (location.pathname === "/login") {
            return;
        }
        tenantListTree()
            .then((res: any) => {
                const tenantList = res.data || [];
                const tenantType = getUrlParams(
                    window.location.href
                )?.tenantType;
                const tenantCode = MAP_TENANT_FIRST_CODE[tenantType];
                // 链接中默认选中租户
                let defaultTenant = tenantList.find(
                    (_: any) => _.tenantCode == tenantCode
                );
                // 接口返回的默认租户
                if (!defaultTenant) {
                    defaultTenant = tenantList.find((_: any) => _.selectStatus);
                }
                //    托底选中租户
                if (!defaultTenant && tenantList.length == 1) {
                    defaultTenant = tenantList[0];
                }

                if (defaultTenant) {
                    switchTenant(defaultTenant)
                        .then((res) => {
                            store.dispatch({
                                type: "setFirstTenant",
                                value: defaultTenant,
                            });
                        })
                        .catch((err) => {
                            console.error("err: ", err);
                        });
                } else {
                    history.replace("/tenant");
                }
            })
            .catch(() => {
                history.replace("/tenant");
            });
    }, []);

    const getFlowBySort = (sort: number) => {
        return defaultFlow.current.find((item: Flow) => item.sort == sort);
    };

    const getMicroUrl = (url: string) => {
        if (!url) return "";
        const urlList = url.split("com/") || [];
        let matchedKey = Object.keys(subAppMap).find((key) =>
            url?.includes(key)
        );

        return matchedKey
            ? subAppMap[matchedKey].activeRule +
            "/" +
            urlList[1]
                ?.replace("?showMenu=false", "")
                .replace(matchedKey + "/", "")
            : url;
    };
    const transferMenuTree = (menuList: any[]): any => {
        return menuList.map((item: any, index: number) => {
            let url = "";
            let children = undefined;
            if (item.url) {
                url = getMicroUrl(item?.url);
            } else {
                children = transferMenuTree(item.children);
            }

            return {
                title: item.resName,
                name: item.resName,
                label: item.resName,
                key: item.resCode,
                id: item.resCode,
                subMenu: children,
                children,
                url,
            };
        });
    };
    useEffect(() => {
        if (!firstTenant.tenantCode) {
            return;
        }
        defaultFlow.current = getFlow(firstTenant.tenantCode);
        saasTree({
            tenantCode: firstTenant.tenantCode,
            appId: process.env.REACT_APP_APP_ID,
            ifChangeCrmUrl: false,
        })
            .then((res: any) => {
                if (res.code === "N0000") {
                    const menu = res.result?.saasData?.children || [];
                    const erp = res.result?.erp;
                    sessionStorage.setItem("erp", erp);
                    sessionStorage.setItem(
                        "tenantCode",
                        firstTenant.tenantCode ?? ""
                    );

                    try {
                        /**
                         * 设置埋点公参
                         */
                        (window as any).JA.tracker.setErp(erp);
                        (window as any).jaq.push([
                            "extParams",
                            JSON.stringify({
                                tenantCode: firstTenant.tenantCode,
                                erp,
                                salesmanId: res.result?.salesmanId,
                            }),
                        ]);
                    } catch (error) { }

                    menu.forEach((item: any) => {
                        const flowItem = getFlowBySort(item.sort);

                        if (flowItem) {
                            if (item.url) {
                                item.children = undefined;
                                item.url = getMicroUrl(item.url);
                            } else if (item.children && item.children.length) {
                                item.children = transferMenuTree(item.children);
                            }
                            if (flowItem.subMenu) {
                                flowItem.subMenu?.push({
                                    title: item.resName,
                                    key: item.resCode,
                                    name: item.resName,
                                    label: item.resName,
                                    url: item.url || "",
                                    children: item.children?.length
                                        ? item.children
                                        : undefined,
                                });
                            } else {
                                // 没有二级菜单，直接设置url
                                flowItem.url = item.url || "";
                            }
                        } else {
                            if (item.sort === 50) {
                                defaultFlow.current.push({
                                    icon: "HomeOutlined",
                                    title: item.resName,
                                    key: item.resCode,
                                    name: item.resName,
                                    label: item.resName,
                                    url: item.url || "",
                                    subMenu: item.children?.length
                                        ? transferMenuTree(item.children)
                                        : undefined,
                                });
                            }
                        }
                    });

                    const activeMenuInfo = getSaasActiveMenuInfo(
                        defaultFlow.current as any[]
                    );

                    store.dispatch({
                        type: "setSubMenuList",
                        value: activeMenuInfo?.activeSubMenu,
                    });

                    store.dispatch({
                        type: "setFlowAndOtherActive",
                        value:
                            activeMenuInfo.activeFlow?.key ||
                            getFlowBySort(0)?.key,
                    });
                    store.dispatch({
                        type: "setFlow",
                        value:
                            defaultFlow.current.filter(
                                (it: any) => it?.subMenu?.length || it.url
                            ) || [],
                    });
                    store.dispatch({
                        type: "setUserInfo",
                        value: {
                            erp,
                            userName: res.result.userName,
                        },
                    });
                    store.dispatch({
                        type: "setFirstTenant",
                        value: {
                            ...firstTenant,
                            appIcon: res.result?.appIcon,
                            appName: res.result?.appName,
                        },
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, [firstTenant.tenantCode]);

    const getDefaultMenu = (flowList: Flow[]) => {
        for (const item of flowList) {
            if (item?.url) {
                return item;
            }
            if (item?.subMenu?.[0]?.url) {
                return item.subMenu[0];
            }
            if (item?.subMenu?.[0]?.children?.[0].url) {
                return item?.subMenu?.[0]?.children?.[0];
            }
        }
    };

    useEffect(() => {
        if (!location.pathname || flow.length === 0) return;
        const workbenchMenu = flow.find(
            (item: any) => item.key === "workbench"
        );
        const homeMenu = flow.find((item: any) => item.key === "home");

        // 页面默认跳转到门户页（home）
        if (
            location.pathname === "/home" ||
            getPathUrl().includes("gongdan/#/home")
        ) {
            let url: any = "";
            switch (firstTenant.tenantCode) {
                case MAP_TENANT_FIRST_CODE[TENANT_ENV.JDDJ]:
                    url = workbenchMenu?.url ?? getDefaultMenu(flow)?.url;
                    break;
                default:
                    url = homeMenu ? "/home" : getDefaultMenu(flow)?.url;
            }

            if (url) {
                url =
                    url?.indexOf("http") !== -1
                        ? `/iframe-view/${encodeURIComponent(url)}`
                        : url;
                history.push(url);
            }
        }

        // 监听路由变化，处理二级菜单，高亮等问题
        const activeMenuInfo = getSaasActiveMenuInfo(flow);

        store.dispatch({
            type: "setChildMenu",
            value: activeMenuInfo?.activeChildMenu || {},
        });
        store.dispatch({
            type: "setSubMenuList",
            value: activeMenuInfo?.activeSubMenu || [],
        });
        store.dispatch({
            type: "setFlowAndOtherActive",
            value: activeMenuInfo?.activeFlow?.key,
        });
    }, [location.pathname, location.hash, flow]);

    let Layout = LrLayout;
    let HomeCom = layoutMode === "sr" ? Home : LsHome;

    return (
        <Switch>
            <Route path="/cover" render={() => <Cover />}></Route>
            <Route path="/tenant" render={() => <Tenant />}></Route>
            <Route path="/login" render={() => <Login />}></Route>

            <Route path="/">
                <Layout>
                    <Switch>
                        {/* 基座路由 */}
                        <Route path="/home" exact component={HomeCom} />

                        {/* 内嵌形式路由 */}
                        <Route path="/iframe-view/*" component={IframeView} />

                        {/* 子应用形式路由 */}
                        {subApp.map((sub) => (
                            <Route
                                key={sub.name}
                                path={`${sub.activeRule}/*`}
                                component={MicroAppView}
                            />
                        ))}
                        <Route
                            exact
                            path="/"
                            render={() => <Redirect to="/home" />}
                        />

                        {/* 无法匹配的路由，一律由 iframe 形式展示 */}
                        <Route path="*" component={IframeView} />
                    </Switch>
                    {/* {pathname !== "/home" && <CollectPage />} */}
                </Layout>
            </Route>

            {/*<Route path="*" component={Error404}/>*/}
        </Switch>
    );
}

export default App;
